import { ListItemText } from "@mui/material";
import React, { ReactNode } from "react";
import * as Styled from "./PageNavMenuItem.styles";

export interface IPageNavMenuItemProp {
    classes?: string;
    hidden?: boolean;
    isActive: boolean;
    title: string | ReactNode;
    subElement?: ReactNode;
    stopPropagation?: boolean;
    onToggleMenuItem: () => void;
}

export class PageNavMenuItem extends React.Component<IPageNavMenuItemProp, {}> {
    handleClick = (e) => {
        const props = this.props;
        if (props.stopPropagation) {
            e.stopPropagation();
        }
        props.onToggleMenuItem();
    };

    render() {
        const props = this.props;
        if (props.hidden) return null;
        return (
            <Styled.MenuItem onClick={props.onToggleMenuItem ? this.handleClick : null} selected={props.isActive}>
                <ListItemText primaryTypographyProps={{ variant: "body2", color: props.isActive ? "primary" : "inherit", fontWeight: props.isActive ? 600 : 400 }}>{props.title}</ListItemText>
                {props.subElement}
            </Styled.MenuItem>
        );
    }
}